import * as actions from './retailer.action';
import reducer from './retailer.reducer';

export default {
  actions,
  reducer,
};
